<template>
  <v-container
    data-app
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout wrap>
      <!-- Overview form -->
      <v-flex
        md6
        sm6
        lg6
      >
        <material-card
          :title="titleProjectSummary"
          color="general"
          text="Summary of Project"
        >
          <v-layout row>
            <v-flex
              md6
              sm6
              lg6
            >
              <v-text-field
                :value="projectOverview.companyName"
                readonly
                color="green"
                label="Company Client"
              />
            </v-flex>
            <v-flex
              md6
              sm6
              lg6
            >
              <v-text-field
                :value="projectOverview.picName"
                readonly
                color="green"
                label="Project PIC"
              />
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex
              md6
              sm6
              lg6
            >
              <v-text-field
                :value="projectOverview.startDate"
                readonly
                color="green"
                label="Project Start Date"
            /></v-flex>
            <v-flex
              md6
              sm6
              lg6
            >
              <v-text-field
                :value="projectOverview.endDate"
                readonly
                color="green"
                label="Project End Date"
              />
            </v-flex>
          </v-layout>

          <v-input
            :messages="['Project Completeness']"
            prepend-icon="mdi-calendar-clock"
          >
            <v-progress-circular
              :rotate="-90"
              :size="100"
              :width="15"
              :value="projectOverview.projectPctg"
              :color="colorProgress"
            >
              {{ projectOverview.projectPctg }}%
            </v-progress-circular>
          </v-input>
        </material-card>
      </v-flex>
      <!-- Data table summary user -->
      <v-flex
        md12
        sm12
        lg6
      >
        <material-card
          color="general"
          title="Summary User Visit & Task"
          text="Project Visited & Task Finished"
        >
          <v-data-table
            :headers="summaryTableVisitTaskHeader"
            :items="projectOverview.visitUserAndTask"
            hide-actions
          >
            <template
              slot="items"
              slot-scope="{ index, item }"
            >
              <td>{{ item.username }} ({{ item.name }})</td>
              <td>{{ item.totalVisit }}</td>
              <td>{{ item.totalTaskAssigned }}</td>
              <td>{{ item.totalTaskDone }}</td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
      <!-- PRo Det Phase -->
      <v-flex
        md12
        sm12
        lg12
      >
        <material-card
          color="general"
          title="Project Detail Phase - List of Task"
          text="Project Tasks per Phase"
        >
          <pro-det-phase
            :pid="pid"
            @callSnack="callSnack"
            @refresh="getProjectOverview"/>
        </material-card>
      </v-flex>
    </v-layout>
    <v-snackbar
      v-model="snack"
      :timeout="5000"
      :color="snackColor">
      {{ snackText }}
      <v-icon
        size="16"
        @click="snack = false"
      >
        mdi-close-circle
      </v-icon>
    </v-snackbar>
  </v-container>
</template>

<script>
  import ProDetPhase from './ProDetPhase'
  export default {
    name: 'ProjectOverview',
    components: { ProDetPhase },
    props: {
    },
    data () {
      return {
        snack: false,
        snackColor: '',
        snackText: '',
        projectOverview: {
          visitUserAndTask: [],
          companyName: '',
          projectName: '',
          projectRefNo: '',
          startDate: '',
          endDate: '',
          projectPctg: 0,
          currentVisit: 0,
          picName: ''
        },
        pid: this.$route.query.pid,
        summaryTableVisitTaskHeader: [
          { sortable: false, text: 'Username', value: 'username' },
          { sortable: false, text: 'Total Visit', value: 'totalVisit' },
          { sortable: false, text: 'Total Task Assigned', value: 'totalTaskAssigned' },
          { sortable: false, text: 'Total Task Done', value: 'totalTaskDone' }
        ]
      }
    },
    computed: {
      titleProjectSummary () {
        return this.projectOverview.projectName + ' [' + this.projectOverview.projectRefNo + ']'
      },
      colorProgress () {
        if (this.projectOverview.projectPctg <= 30) {
          return 'red'
        } else if (this.projectOverview.projectPctg > 30 && this.projectOverview.projectPctg < 70) {
          return 'orange'
        } else {
          return 'green'
        }
      }
    },
    created () {
      // let id = this.$route.query.nid // query params -> id visit from directURL
      this.getProjectOverview()
    },
    methods: {
      async getProjectOverview () {
        try {
          // let pid = this.$route.query.pid // query params -> projectid from directURL
          let response = await this.$http.get(`/api/project/overview/${this.pid}`)

          console.debug(response)
          this.projectOverview = response.data
        } catch (error) {
          console.log(error)
        }
      },

      // toasts/snackbar messages for actions
      saveInline () {
        console.debug('save inline parent')
        this.snack = true
        this.snackColor = 'info'
        this.snackText = 'Data saved/updated'
      },
      cancelInline (message) {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = message || 'Canceled'
      },
      deleteInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data removed'
      },
      reset () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data reset to default'
      },
      openInline () {
        this.snack = true
        this.snackColor = 'info'
        this.snackText = 'Edit mode opened'
      },
      closeInline () {
        this.snack = true
        this.snackColor = 'warning'
        this.snackText = 'Cancel Update'
      },
      callSnack (type, msg) {
        switch (type) {
          case 'saveInline':
            this.saveInline()
            break
          case 'closeInline':
            this.closeInline()
            break
          case 'openInline':
            this.openInline()
            break
          case 'deleteInline':
            this.deleteInline()
            break
          case 'cancelInline':
            this.cancelInline(msg)
            break
        }
      }
    }
  }
</script>

<style scoped>

</style>
